import ENV from "../env";

async function getBartrackPoursSummary(locationUUID, fromDate, toDate) {
  try {
    const today = new Date();

    const response = await fetch(`${ENV.firebaseApiUrl}/bartrack/pours-summary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        location_uuid: locationUUID,
        from_date: fromDate || new Date(today.getTime() - 30 * 86400000),
        to_date: toDate || today,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Request failed");
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching pours summary:", error.message);
  }
}
export default getBartrackPoursSummary;
